import {AfterContentInit, Directive, ElementRef, Input} from '@angular/core';

@Directive({
  selector: '[ncAutofocus]'
})
export class AutoFocusDirective implements AfterContentInit {

  @Input() public shouldAutofocus: boolean;

  public constructor(private el: ElementRef) {
  }

  ngAfterContentInit(): void {
    if (this.shouldAutofocus) {
      setTimeout(() => {
        const element = this.el.nativeElement.querySelector('input, textarea');
        if (element) {
          element.focus();
        }
      }, 0);
    }
  }
}
